var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"width":"80%","title":_vm.title},on:{"closed":function($event){return _vm.$emit('closed')}}},[_c('UdfRuntime',{attrs:{"id":_vm.id,"runtime":_vm.data,"version":_vm.version}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }